/**
 * Global Privacy Control (GPC) detection.
 *
 * GPC is the modern CCPA / CPRA opt-out signal. Under California AG
 * enforcement (Sephora settlement 2022, CPRA §1798.135(b)(1)(B)), a
 * visitor sending `Sec-GPC: 1` is legally equivalent to someone who
 * clicked "Do Not Sell My Personal Information". We honor it by forcing
 * strict consent mode regardless of IP geo.
 *
 * DNT (Do Not Track) is a deprecated legacy signal, we do NOT honor it
 * as a CCPA opt-out because courts and AGs have converged on GPC.
 */
export const isGpcEnabled = (): boolean => {
  if (typeof navigator === "undefined") return false
  const val = (navigator as Navigator & { globalPrivacyControl?: boolean })
    .globalPrivacyControl
  return val === true
}
